import { BpmRolesAdd } from "@/modules/admin-panel/widgets/bpm-roles/add";
import { BpmRolesList } from "@/modules/admin-panel/widgets/bpm-roles/list/bpm-roles-list";
import Card from "@/shared/data-display/card";
import Page from "@/shared/page";
import { useTranslations } from "use-intl";
import { BPM_ROLES_MAIN_PATH } from "./bpm-roles-main-path";
import { BpmRolesListItemOptions } from "@/modules/bpm/widgets/bpm-roles-list-item-options";

export default function BpmRolesMainPage() {
  const t = useTranslations("BpmRolesMainPage");

  return (
    <Page
      title={t("Bpm roles")}
      breadcrumbsOptions={{
        path: BPM_ROLES_MAIN_PATH,
      }}
    >
      <Card title={t("Bpm roles")} extra={<BpmRolesAdd />}>
        <BpmRolesList Options={BpmRolesListItemOptions} />
      </Card>
    </Page>
  );
}
